export const calculateVoucherCoverage = (totalAmount, voucherAmount) => {
  if (voucherAmount > totalAmount) {
    return totalAmount;
  } else {
    return voucherAmount;
  }
};
